import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

// Modules
import { SharedModule }      from 'src/app/shared/shared.module';
import { WebTemplateModule } from 'src/app/web-template/web-template.module';

// Elements
import { ContactDataComponent } from './elements/contact-data/contact-data.component';
import { ContactFormComponent } from './elements/contact-form/contact-form.component';

// Pages
import { LandingPageComponent }   from './pages/landing-page/landing-page.component';
import { CampusComponent }        from './pages/campus/campus.component';
import { GoalsComponent }         from './pages/goals/goals.component';
import { ProfessorateComponent } from './pages/professorate/professorate.component';
import { ContactComponent }       from './pages/contact/contact.component';
import { CookiesPolicyComponent } from './pages/cookies-policy/cookies-policy.component';
import { LegalAdviceComponent }   from './pages/legal-advice/legal-advice.component';

@NgModule({

    declarations: [
        ContactDataComponent,
        ContactFormComponent,
        CampusComponent,
        ContactComponent,
        CookiesPolicyComponent,
        GoalsComponent,
        LandingPageComponent,
        LegalAdviceComponent,
        ProfessorateComponent
    ],
    
    imports: [
        CommonModule,
        SharedModule,
        WebTemplateModule
    ],

    exports: [
        CampusComponent,
        ContactComponent,
        CookiesPolicyComponent,
        GoalsComponent,
        LandingPageComponent
    ]

})
export class CampusModule { }
